import styled from 'styled-components';

export const Container = styled.div`
  img {
    height: ${({ starSize }) => (starSize ? `${starSize}px` : '15px')};
    width: ${({ starSize }) => (starSize ? `${starSize}px` : '15px')};
    margin: auto 2px;
  }
`;
